module.exports = __webpack_public_path__ + "static/media/skyatlas.57c1dab3.svg";